module.exports = __webpack_public_path__ + "static/john-robbins.6eec0977.jpg";